import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { GoChecklist } from "react-icons/go";
import GroupingItem from "../../Components/GroupingItem";
import Loading from "../../Components/Loading";
import { useCategories } from "./Hooks";

const Categories = () => {
  const { loading, init, changeObj, dispatch, getValue, navigate } =
    useCategories();

  return (
    <>
      <div className="tiTle">
        {getValue("category_id") ? (
          <button
            className="btn"
            onClick={() => {
              changeObj("category_id", "");
            }}
          >
            <BsArrowRight />
          </button>
        ) : (
          <GoChecklist />
        )}

        <p className="txt">
          {getValue("category_id") ? (
            <>
              {
                init?.categories?.filter(
                  ca => ca.id == getValue("category_id")
                )[0].title
              }
            </>
          ) : (
            <>دسته بندی آگهی ها</>
          )}
        </p>
      </div>
      <div className="container">
        <div className="row">
          {loading.get ? (
            <Loading height={"30px"} count={5} />
          ) : (
            <>
              {getValue("category_id") ? (
                <>
                  {init.categories
                    .filter(ca => ca.id == getValue("category_id"))[0]
                    .childs.map((item, key) => {
                      return (
                        <div key={key} className="col-12">
                          <GroupingItem
                            item={item}
                            onClick={() => {
                              dispatch("category", item);
                              localStorage.setItem("isParent", false);
                              navigate("/list");
                            }}
                          />
                        </div>
                      );
                    })}
                </>
              ) : (
                init.categories.map((item, key) => {
                  return (
                    <div key={key} className="col-12">
                      <GroupingItem
                        item={item}
                        onClick={() => {
                          if (item.childs?.length > 0) {
                            changeObj("category_id", item.id);
                          } else {
                            dispatch("category", item);
                          }
                        }}
                      />
                    </div>
                  );
                })
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Categories;
